import ReCAPTCHA from "react-google-recaptcha";
import { forwardRef } from "react";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

// Thin wrapper around react-google-recaptcha so every registration / reset-password
// form uses the same site key and `data-testid`-friendly container.
export const RecaptchaCheckbox = forwardRef(function RecaptchaCheckbox({ onChange, testId = "recaptcha" }, ref) {
  if (!SITE_KEY) {
    return (
      <div className="text-xs text-terracotta-dark" data-testid={`${testId}-missing-key`}>
        reCAPTCHA site key is missing — set <code>REACT_APP_RECAPTCHA_SITE_KEY</code> and reload.
      </div>
    );
  }
  return (
    <div data-testid={testId} className="min-h-[78px]">
      <ReCAPTCHA
        ref={ref}
        sitekey={SITE_KEY}
        onChange={(token) => onChange(token || "")}
        onExpired={() => onChange("")}
        onErrored={() => onChange("")}
      />
    </div>
  );
});
